import { render, staticRenderFns } from "./RelationDiagram.vue?vue&type=template&id=1adb8e4e&scoped=true"
import script from "./RelationDiagram.vue?vue&type=script&lang=js"
export * from "./RelationDiagram.vue?vue&type=script&lang=js"
import style0 from "./RelationDiagram.vue?vue&type=style&index=0&id=1adb8e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb8e4e",
  null
  
)

export default component.exports